const formatMinutes = (mins) => {
	if (!Number.isFinite(mins)) return '--';
	const total = Math.round(mins);
	const hours = Math.floor(total / 60);
	const minutes = total % 60;
	if (hours && minutes) return `${hours}h ${minutes}m`;
	if (hours) return `${hours}h`;
	return `${minutes}m`;
};

export default formatMinutes;
